import { Trans, useTranslation } from 'react-i18next';

import { Images } from '../../../constants/images';
import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import {
  BasicPopupContainer,
  PopUpButtonColors,
} from '../Containers/BasicPopupContainer';

import styles from './AboutJOYCashPopup.module.css';

type AboutJOYCashPopupProps = {
  cashOutRequirement: string;
  onPrimary: () => void;
};

export const AboutJOYCashPopup = (props: AboutJOYCashPopupProps) => {
  const { cashOutRequirement, onPrimary } = props;

  const { t } = useTranslation();

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.JOYCashWeb}
          width={80}
          height={80}
          color="black"
        />
        <div className={styles.title}>{t('About JOY Cash')}</div>

        <div className={styles.description}>
          {t(
            'JOY Cash can be redeemed once you accumulate {amount} or more. Redemption requests must be submitted one month in advance and will be processed on the 15th of each month.',
            { amount: cashOutRequirement },
          )}
        </div>

        <hr className={styles.divider} />

        {/* <div className={styles.content}> */}
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <Trans i18nKey="About JOY Cash Available Reward">
              <span className={styles.boldText}>Available Reward</span>
              is the amount of reward that can be requested for cash out.
            </Trans>
          </li>
          <li className={styles.listItem}>
            <Trans i18nKey="About JOY Cash Confirmed Reward">
              <span className={styles.boldText}>Confirmed Reward</span>
              converts to Available Reward over two months - 50% becomes
              available in the first month, and the remaining 50% becomes
              available in the second month.
            </Trans>
          </li>
          {/* <li className={styles.listItem}>
            <Trans i18nKey="About JOY Cash Potential Reward">
              <span className={styles.boldText}>Potential Reward</span>
              shows the projected reward amount you could earn from your current
              referrals who have not made purchases yet. This is an estimated
              figure based on potential purchase activities.
            </Trans>
          </li> */}
        </ul>
        {/* </div> */}
      </div>
    </BasicPopupContainer>
  );
};

type AboutWEACashPopupProps = {
  onPrimary: () => void;
};

export const AboutWEACashPopup = (props: AboutWEACashPopupProps) => {
  const { onPrimary } = props;

  const { t } = useTranslation();

  return (
    <BasicPopupContainer
      primaryButtonColor={PopUpButtonColors.WEA_PRIMARY}
      onPrimaryButtonClick={onPrimary}
    >
      <div className={styles.popupContent}>
        <img className={styles.logo} src={Images.WEA_Web_IMG_WEACash01} />
        <div className={styles.title}>{t('About WEA Cash')}</div>

        <div className={styles.description}>
          {t(
            'WEA Cash can be spent to reduce the price of your future WEA course purchases.',
          )}
        </div>

        {/* <div className={styles.content}> */}
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <Trans i18nKey="About WEA Cash Available Reward">
              <span className={styles.boldText}>Available Reward</span>
              is the amount of WEA Cash that can be can be spent to reduce the
              price of your future WEA course purchases.
            </Trans>
          </li>
          <li className={styles.listItem}>
            <Trans i18nKey="About WEA Cash Confirmed Reward">
              <span className={styles.boldText}>Confirmed Reward</span>
              is the total reward amount earned from actual purchases made by
              your referred users. Once your referred users complete their
              purchases, the Confirmed Reward will become Available Reward after
              one month.
            </Trans>
          </li>
          {/* <li className={styles.listItem}>
            <Trans i18nKey="About WEA Cash Potential Reward">
              <span className={styles.boldText}>Potential Reward</span>
              shows the projected reward amount you could earn from your current
              referrals who have not made purchases yet. This is an estimated
              figure based on potential purchase activities.
            </Trans>
          </li> */}
        </ul>
        {/* </div> */}
      </div>
    </BasicPopupContainer>
  );
};
